var Class      = require('Class');
var Events     = require('Events');
var $          = require('jquery');
var utils      = require('Utils');
var Collection = require('Collection');
var ContainersCollection;
var Layer;
var Visualization;
var LayerObject;
var Container;

var createContainer = function (container_obj, project) {
    var cont;

    if (container_obj.style_mode && container_obj.style_mode == 3){
        cont = new Visualization(container_obj, project);
    }
    else {
        switch (container_obj['type']) {
            case 'layer':
            case 'virtual':
            case 'material':
                cont = new Layer(container_obj, project);
                break;
            default:
                cont = new Container(container_obj, project);
        }
    }

    return cont;
};

/**
 * @class
 */
var Project = Class.extend({

    includes: Events,

    options: {
        apiUrl : '',
        mapCode: ''
    },

    /**
     * Класс проекта oms реализующий работу с данными опубликованной карты
     *
     * @class Project
     * @namespace omjs
     * @extends Class
     * @constructor
     *
     * @example
     *     var container = new omjs.Project.Container({
     *         project: projectInstance,
     *         ...
     *     });
     */
    initialize: function (options) {
        var that = this;
        if (!$.isPlainObject(options)) {
            throw new Error('No options specified');
        }

        that.setOptions(options);

        that.token = that.options.token || false;
        that.lng = that.options.lng || false;
        that.objects_editable = that.options.objects_editable || false;

        // Validate apiUrl option
        that.options['apiUrl'] = ('' + that.options['apiUrl']).trim();

        if (!that.options['apiUrl']) {
            throw new Error('No apiUrl option specified');
        }

        // Добавляем слеш к урле в конце, если её небыло
        that.options['apiUrl'] = utils.getUrlWithEndSlash(that.options['apiUrl']);

        // TODO: Убрать когда сервак будет отдавать правильную URL
        if (~that.options['apiUrl'].indexOf('%version')) {
            that.options['apiUrl'] = that.options['apiUrl'].replace('/%version/', '/'+omjs.version+'/');
        } else {
            that.options['apiUrl'] = that.options['apiUrl'].replace('/2.0/', '/'+omjs.version+'/');
        }

        that._originalTilesUrl = false;
        if(that.options['tilesUrl']){
            that._originalTilesUrl = that.options['tilesUrl'];
            that._addParamsToTilesUrl();
        }

        // Validate mapCode option
        that.options['mapCode'] = ('' + that.options['mapCode']).trim();

        if (!that.options['mapCode']) {
            throw new Error('No mapCode option specified');
        }

        that.apiUrlLocation = that._getApiLocation();

        ContainersCollection = require('./ContainersCollection');
        Layer                = require('./Layer');
        Visualization        = require('./Visualization');
        Container            = require('./Container');
        LayerObject          = require('./LayerObject');

        that._cache = {
            // containers       : new ContainersCollection(),
            // publishContainers: new ContainersCollection()
        };
        that.contsDeferred = {};
    },
    /**
     * Дополнительные параметры в URL тайлов
     * @returns {Project}
     * @private
     */
    _addParamsToTilesUrl: function(){
        var that = this;
        if(!that.options['tilesUrl']){
            return that;
        }
        that.options['tilesUrl'] = that._originalTilesUrl;
        if(that.token){
            that.options['tilesUrl'] += '&token='+that.token;
        }
        if(that.lng){
            that.options['tilesUrl'] += '&lng='+that.lng;
        }
        return that;
    },

    /**
     *
     * @returns {*}
     * @private
     */
    _getUrlWithMapCode: function () {
        var that = this;
        return utils.getUrlWithEndSlash(that.options['apiUrl'] + that.options['mapCode']);
    },

    _getApiLocation: function(){
        var that = this;
        var l = document.createElement("a");
        l.href = that.options.apiUrl;
        if (!l.origin) {
            l.origin = l.protocol + '//' + l.hostname;
        }
        return l;
    },

    /**
     * Авторизация пользователя на проекте
     *
     * @method login
     * @param {String} user - Имя пользователя
     * @param {String} password - Пароль пользователя
     * @return {jQuery.jqXHR}
     */
    login: function (user, password) {
        var that = this;
        var url  = that.options['apiUrl'];

        if (!($.type(user) == 'string' && user.length)) {
            throw new Error('User required');
        }

        if (!($.type(password) == 'string' && password.length)) {
            throw new Error('Password required');
        }

        return $.ajax(url + 'login/', {
            "crossDomain": true,
            "type"       : "post",
            "data"       : {
                user: user,
                pass: password
            }
        }).done(function (resp) {
            that.token = resp.token;
            that._addParamsToTilesUrl();
        });
    },

    /**
     * Завершение авторизованной сессии полльзователя
     *
     * @method logout
     * @return {jQuery.Promise}
     */
    logout: function () {
        var that = this;
        var url  = that.options['apiUrl'];

        return $.when()
            .then(function () {
                return !that.token || $.ajax(url + 'logout/', {
                    "crossDomain": true,
                    "type"       : "post",
                    "data"       : {
                        "token": that.token
                    }
                });
            })
            .done(function () {
                that.token = false;
                that._addParamsToTilesUrl();
            });
    },

    loginToken: function(token){
        var that = this;

        // чтоб нам авторизоваться этим токеном
        // нужно сделать запрос на сервер с этим токеном
        // подойдет запрос на проверку авторизации
        // если сервер нам скажет, что такой пользователь есть,
        // то мы поменяем урлу до тайлов и установим that.token

        that.isAuthorized(token).then(function(is_authorized){
            if (is_authorized) {
                that.token = token;
                that._addParamsToTilesUrl();
            }
        });

    },

    isAuthorized: function(token, set_token_if_authorized){
        var that = this;
        var url  = that.options['apiUrl'];

        token = (token === undefined || token === false) ? that.token : token;

        // token = token || that.token;
        
        // if (!token) {
        //     return $.Deferred().resolve(false);
        // }

        return $.ajax({
            type: "GET",
            url: url + 'authorized/',
            data: {
                token: token
            }
        }).then(function(response){
            // если сервер вернул true
            if (response) {
                if (set_token_if_authorized) {
                    that.token = token;
                    that._addParamsToTilesUrl();
                }
            }
            return response;
        });
    },

    isPublicUser: function(){
        var that = this;
        return that.isAuthorized().then(function(response){
            return !response;
        });
    },

    /**
     * Загружает список контейнеров
     */
    loadContainers: function (options) {
        var that = this;
        var url  = that._getUrlWithMapCode();
        var raw  = false;
        var deferred;

        options || (options = {});

        options = $.extend(true, {
            "type"      : "full",
            "returnCss" : 0
        }, options);

        if (that.token) {
            options['token'] = that.token;
        }
        if (that.lng) {
            options['lng'] = that.lng;
        }
        if (options.type == "publish" && that.objects_editable) {
            options['with_access'] = 1;
        }

        deferred = $.when()
            .then(function() {
                raw = Boolean(options['raw']);

                if (!raw) {
                    options['returnCss']  = 0;
                } else {
                    delete options['raw'];
                }

                return $.ajax(url + 'layers/', {
                    "crossDomain": true,
                    "data"       : options
                });
            })
            .then(function(response) {
                var collection;

                if (raw) {
                    return response;
                }

                collection = new ContainersCollection();

                response.forEach(function (container_obj) {
                    collection.add(createContainer(container_obj, {project: that}));
                });

                return collection;
            });

        return deferred;
    },

    getContainers: function (options) {
        var that = this;

        options || (options = {});

        options = $.extend(true, {
            "type"      : "full"
        }, options);

        options['returnCss']  = 0;
        delete options['raw'];

        return $.when()
            .then(function () {
                if (!that.contsDeferred[options['type']]) {
                    that.contsDeferred[options['type']] = that.loadContainers(options);
                }

                return that.contsDeferred[options['type']];
            })
            .then(function(containers){
                var containersAttr;
                // Определяем, кеш чего нам нужен. Публичных контейнеров или полное дерево.
                containersAttr = (options['type'] == 'full') ? 'containers' : 'publishContainers';

                // Если кеш еще пуст - заполняем его
                if (!that._cache[containersAttr]) {
                    that._cache[containersAttr] = containers;
                }

                return containers;
            });
    },

    /**
     * Загружает список слоев (без папок и карт !!!) используя метод loadContainers
     */
    loadLayers: function (options) {
        var that = this;
        options || (options = {});

        options = $.extend(true, {
            "type"      : "full",
            "returnCss" : 0
        }, options);

        // Нельзя грузить контейнеры в "сыром" виде для получения слоёв.
        if ('raw' in options) {
            delete options['raw'];
        }

        return that.loadContainers(options)
            .then(function (collection) {
                return collection.filter(function (container) {
                    return Boolean(~$.inArray(container.get('type'), ['layer', 'virtual', 'material', 'raster']));
                });
            });
    },

    getLayers: function (options) {
        var that = this;

        return that.getContainers(options)
            .then(function (collection) {
                return collection.filter(function (container) {
                    var cont_type = (container.get)?container.get('type'):container['type'];
                    return Boolean(~$.inArray(cont_type, ['layer', 'virtual', 'material', 'raster']));
                });
            });
    },

    /**
     * Загрузка слоя опубликованной карты по его коду
     *
     * @param {String} layer_code - код слоя
     * @param {Object} [options] - опции
     * @param {Boolean} [options.raw=false] - `true` - не обрабатывать ответ с сервера
     * @return {jQuery.jqXHR}
     */
    loadLayer: function (layer_code, options) {
        var that = this,
            url  = that._getUrlWithMapCode(),
            raw  = false;

        if (typeof layer_code != 'string') {
            throw new Error('layer_code is not a String or undefined');
        }

        options || (options = {});
        options = $.extend(true, {}, options);

        if ('raw' in options) {
            raw = Boolean(options['raw']);
            delete options['raw'];
        }

        if (that.token) {
            options['token'] = that.token
        }
        if (that.lng) {
            options['lng'] = that.lng
        }

        return $.ajax(url + 'layers/' + layer_code + '/', {
                "crossDomain": true,
                "data"       : options
            })
            .then(function (response) {
                if (raw) return this;

                return createContainer(response, {project: that})
            });
    },

    /**
     * Загрузка полной информации по объекту
     *
     * @method loadObjects
     * @param {String} layerCode - код слоя
     * @param {Object} [options] - опции
     * @param {Boolean} [options.raw=false] - `true` - не обрабатывать ответ с сервера
     * @param {String[]} [options.fields] - массив кодов полей, значения которых также попадут в результат
     * @param {any} [options.*] - все параметры которые поддерживает сервер
     * @returns {jQuery.jqXHR}
     *
     * @example
     *      var layers;
     *      omjs.initProject(config)
     *      .then(function(project){
     *          return project.loadLayers();
     *      })
     *      .then(function(layers){
     *          layersColection = layers;
     *          return layers.loadObjects();
     *      })
     *      .then(function(objects){
     *          // Работаем с объектами
     *      });
     */
    loadObjects: function (layerCode, options) {
        var that = this,
            url  = that._getUrlWithMapCode(),
            raw  = false;

        if ($.type(layerCode) !== 'string') {
            // TODO: Нужно нормальное описание ошибки.
            throw new Error('layerCode is not a string')
        }

        options || (options = {});
        options = $.extend(true, {}, options);

        if ('raw' in options) {
            raw = Boolean(options['raw']);
            delete options['raw'];
        }

        if (that.token) {
            options['token'] = that.token
        }
        if (that.lng) {
            options['lng'] = that.lng
        }

        if ('fields' in options) {

            // Если передали не массив - грохаем опцию.
            // Тут может быть только массив строк
            if (typeof options['fields'] == 'string') {
                options['fields'] = [options['fields']];
            }
            if (!$.isArray(options['fields'])) {
                throw new Error('option -fields-  mast be Array');
            }
            // Переводим в нужный серверу формат
            options['fields'] = options['fields'].join(',');
        }

        // TODO: Нужно дописать обработчик fail-а.
        return $.ajax(url + 'layers/' + layerCode + '/objects/', {
            crossDomain: true,
            data       : options
        }).then(function (response) {

            var objects;
            if (raw) return response;

            objects = response.map(function (obj) {
                var objId     = obj['id'];
                var objFields = obj['fields'];
                delete obj['id'];
                delete obj['fields'];
                obj['layerCode'] = layerCode;
                return new LayerObject(objId, objFields, obj);
            });

            return new Collection(objects);
        });
    },

    /**
     * Загрузка полной информации по объекту
     *
     * @method loadObject
     * @param {String} layerCode - код слоя
     * @param {Number} objectId - id запрашиваемого объекта
     * @param {Object} [options] - опции
     * @param {Boolean} [options.raw=false] - `true` - не обрабатывать ответ с сервера
     * @param {*} [options.*] - все параметры которые поддерживает сервер
     * @returns {jQuery.jqXHR}
     */
    loadObject: function (layerCode, objectId, options) {
        var that   = this,
            url    = that._getUrlWithMapCode(),
            raw    = false,
            objUrl = "";

        if ($.type(layerCode) !== 'string') {
            // TODO: Нужно нормальное описание ошибки.
            throw new Error('`layerCode` is not String')
        }

        if ($.type(objectId) !== 'number') {
            // TODO: Нужно нормальное описание ошибки.
            throw new Error('`objectId` is not Number')
        }

        options || (options = {});
        options = $.extend(true, {}, options);

        if ('raw' in options) {
            raw = Boolean(options['raw']);
            delete options['raw'];
        }

        if (that.token) {
            options['token'] = that.token
        }
        if (that.lng) {
            options['lng'] = that.lng
        }

        // TODO: Нужно дописать обработчик fail-а.
        objUrl = utils.getUrlWithEndSlash(url + 'layers/' + layerCode + '/objects/' + objectId);
        return $.ajax(objUrl, {
            crossDomain: true,
            data       : options
        }).then(function (obj) {
            var objId  = obj['id'];
            var fields = obj['fields'];

            if (raw) {
                return obj;
            }

            delete obj['id'];
            delete obj['fields'];

            obj['layerCode'] = layerCode;

            return new LayerObject(objId, fields, obj);
        });
    },

    loadStructure: function (layerCode, options) {
        var that         = this,
            url          = that._getUrlWithMapCode(),
            raw          = false,
            structureUrl = "";

        if ($.type(layerCode) !== 'string') {
            // TODO: Нужно нормальное описание ошибки.
            throw new Error('`layerCode` is not String')
        }


        options || (options = {});
        options = $.extend(true, {}, options);

        if ('raw' in options) {
            raw = Boolean(options['raw']);
            delete options['raw'];
        }

        if (that.token) {
            options['token'] = that.token;
        }
        if (that.lng) {
            options['lng'] = that.lng;
        }

        if (that.objects_editable) {
            options['with_access'] = 1;
        }

        // TODO: Нужно дописать обработчик fail-а.
        structureUrl = utils.getUrlWithEndSlash(url + 'layers/' + layerCode + '/structure/');
        return $.ajax(structureUrl, {
            crossDomain: true,
            data       : options
        }).then(function (structure) {
            return structure;
        });
    },

    loadLegend: function (layerCode) {
        var that    = this,
            url     = that._getUrlWithMapCode(),
            legendUrl,
            options = {};

        if ($.type(layerCode) !== 'string') {
            // TODO: Нужно нормальное описание ошибки.
            throw new Error('`layerCode` is not String')
        }

        if (that.token) {
            options['token'] = that.token
        }
        if (that.lng) {
            options['lng'] = that.lng
        }

        legendUrl = utils.getUrlWithEndSlash(url + 'layers/' + layerCode + '/legend/');

        return $.ajax(legendUrl, {
            crossDomain: true,
            data       : options
        }).then(function (legend) {
            return legend;
        });
    },

    loadMap: function(options){
        var that = this,
            url  = that._getUrlWithMapCode(),
            raw  = false;

        options || (options = {});
        options = $.extend(true, {}, options);

        if ('raw' in options) {
            raw = Boolean(options['raw']);
            delete options['raw'];
        }

        if (that.token) {
            options['token'] = that.token
        }
        if (that.lng) {
            options['lng'] = that.lng
        }

        return $.ajax(url, {
                "crossDomain": true,
                "data"       : options
            })
            .then(function (response) {
                if (raw) return this;

                return createContainer(response, {project: that})
            });
    },

    deleteObject: function(layer_code, object_id) {
        var that = this;

        var options = {};

        if (that.token) {
            options['token'] = that.token;
        } else {
            throw new Error('Для выполнения этого действия нужен токен');
        }

        var delete_url = (
            that._getUrlWithMapCode() + 'layers/' + layer_code 
            + '/objects/' + object_id + '/' + '?token=' + that.token
        );

        return $.ajax({
            method: "DELETE",
            url: delete_url,
            data: options
        });
    },

    updateObject: function(layer_code, object_id, opt_update_data, opt_update_geom) {
        var that = this;
        var options = {};

        if (that.token) {
            options['token'] = that.token;
        } else {
            throw new Error('Для выполнения этого действия нужен токен');
        }

        var update_url = (
            that._getUrlWithMapCode() + 'layers/' + layer_code 
            + '/objects/' + object_id + '/' + '?token=' + that.token
        );

        var data = {};
        if (opt_update_data) {
            data['fields'] = opt_update_data;
        }

        // Геометрия может прийти null. В таком случае ее надо слать на сервер
        // Т.к. это почти наверняка означает что геометрию очистили и ее больше нет
        if (opt_update_geom !== undefined) {
            data['geom'] = opt_update_geom;
        }

        return $.ajax({
            method: "PUT",
            url: update_url,
            contentType : 'application/json',
            data: JSON.stringify(data)
        });
    },

    createObject: function(layer_code, object_attributes, opt_geom) {
        var that = this;

        var options = {};
        opt_geom = opt_geom || false;

        if (that.token) {
            options['token'] = that.token;
        } else {
            throw new Error('Для выполнения этого действия нужен токен');
        }

        var create_url = (
            that._getUrlWithMapCode() + 'layers/' + layer_code + '/objects/?token=' + that.token
        );

        var post_data = {
            fields: object_attributes,
        };
        if (opt_geom) {
            post_data['geom'] = opt_geom;
        }

        return $.ajax({
            method: "POST",
            url: create_url,
            contentType : 'application/json',
            data: JSON.stringify(post_data),
        }).then(function(object_json) {
            var layer_object = new LayerObject(
                object_json.id,
                object_json.fields,
                {
                    bbox: object_json.bbox,
                    geom: object_json.geom
                }
            );

            return $.Deferred().resolve(layer_object);
        });
    },

    deleteFileFromObject: function(
        layer_code, 
        object_id, 
        field_code, 
        file_id
    ) {
        var that = this;

        var options = {
            field: field_code
        };

        if (that.token) {
            options['token'] = that.token;
        } else {
            throw new Error('Для выполнения этого действия нужен токен');
        }

        var delete_url = (
            that._getUrlWithMapCode() + 
            'layers/' + layer_code 
            + '/objects/'+ object_id 
            + '/files/'+ file_id +'/'
        );

        return $.ajax({
            method: "DELETE",
            url: delete_url,
            data: options
        });
    },

    uploadFileToObject: function(
        layer_code,
        object_id,
        field_code, 
        file_object, 
        opt_additional_data
    ) {
        var that = this;
        opt_additional_data = opt_additional_data || {};

        var form_data = new FormData();

        if (that.token) {
            form_data.append('token', that.token);
        } else {
            throw new Error('Для выполнения этого действия нужен токен');
        }

        form_data.append('file', file_object);
        form_data.append('field', field_code);

        var url = that._getUrlWithMapCode() 
            + "/layers/"+ layer_code 
            + "/objects/"+ object_id +"/files/"
 
        $.each(opt_additional_data, function(key, value) {
            form_data.append(key, value);
        });

        return $.ajax({
            type: 'POST',
            url: url,
            data: form_data,
            processData: false,
            cache: false,
            contentType: false
        });
    }
});

module.exports = Project;



//////////////////
// WEBPACK FOOTER
// ./src/Project/Project.js
// module id = 11
// module chunks = 0